const CHECKOUT_TOKEN_PREFIX = "smfa.checkout_token";

const getCheckoutTokenKey = (applicationId) =>
  `${CHECKOUT_TOKEN_PREFIX}:${applicationId}`;

export const storeCheckoutToken = (applicationId, checkoutToken) => {
  if (!applicationId || !checkoutToken || typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      getCheckoutTokenKey(applicationId),
      checkoutToken,
    );
  } catch (error) {
    window.log?.warn?.(
      "Unable to persist checkout token in session storage",
      error,
    );
  }
};

export const getCheckoutToken = ({ applicationId, checkoutToken } = {}) => {
  if (checkoutToken) {
    return checkoutToken;
  }

  if (!applicationId || typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage.getItem(getCheckoutTokenKey(applicationId));
  } catch (error) {
    window.log?.warn?.(
      "Unable to read checkout token from session storage",
      error,
    );

    return null;
  }
};
